<template>
  <a-card>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-row :gutter="{ xs: 8, sm: 16, md: 24 }">
        <a-col :lg="8" :md="12" :sm="24">
          <a-form-model-item label="企业ID" prop="id">
            <a-auto-complete
              placeholder="请输入企业ID"
              @select="handleSelect"
              @search="handleSearch"
              v-model="form.id"
              :allow-clear="true"
            >
              <template slot="dataSource">
                <a-select-option
                  v-for="item in compList"
                  :key="item.code"
                  :value="JSON.stringify(item)"
                >
                  {{ item.code }}
                </a-select-option>
              </template>
            </a-auto-complete>
          </a-form-model-item>
        </a-col>
        <a-col :lg="8" :md="12" :sm="24">
          <a-form-model-item label="企业名称" prop="name">
            <a-auto-complete
              placeholder="请输入企业名称"
              @select="handleSelect"
              @search="handleSearch"
              v-model="form.name"
              :allow-clear="true"
            >
              <template slot="dataSource">
                <a-select-option
                  v-for="item in compList"
                  :key="item.code"
                  :value="JSON.stringify(item)"
                >
                  {{ item.name }}
                </a-select-option>
              </template>
            </a-auto-complete>
          </a-form-model-item>
        </a-col>
        <a-col style="margin-top: 40px; margin-left:800px">
          <a-form-model-item>
            <a-button @click="handleSubmit">
              下一步
            </a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-card>
</template>

<script>
import { getCustomerList,  checkCom} from '../api'

export default {
  data() {
    return {
      form: {
        id: (this.$route.query && this.$route.query.code) || '',
        name: '',
      },
      rules: {
        id: [
          {
            required: true,
            message: '请输入企业ID',
            trigger: 'blur',
          },
        ],
        name: [
          {
            required: true,
            message: '请输入企业名称',
            trigger: 'blur',
          },
        ],
      },
      compList: [],
      
    }
  },
  async mounted() {
    const code = this.$route.query && this.$route.query.code
    if (code) {
      try {
        const { data } = await getCustomerList(code)
        const selectedValue = data && data.length && data[0]
        this.form.id = selectedValue.code
        this.form.name = selectedValue.name
      } catch (error) {
        console.error(error)
      }
    }
  },
  methods: {
    handleSelect(value) {
      const selectedValue = JSON.parse(value)
      this.form.id = selectedValue.code
      this.form.name = selectedValue.name
      this.compList = []
    },

    async handleSearch(value) {
      if (!value.trim()) {
        return
      }
      try {
        const { data } = await getCustomerList(value)
        this.compList = data
      } catch (error) {
        console.error(error)
      }
    },
    async handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            const company = await this.checkCom()
            if (company) {
              this.$router.push({
                path: `/credit-approval/apply/limit-extension-application-detail/${this.form.id}`,
              })
            }
          } catch (error) {
            console.error(error)
          }
        } else {
          return false
        }
      })
    },
    async checkCom() {
      const companyCode = this.form.id
      try {
        const { data } = await checkCom(companyCode)
        if (data) {
            return true
        }
      } catch (error) {
        console.error(error)
      }
      return false
    },
  },
}
</script>
